// 🪇 ANM — anime.js v4 setup drop-killer
// Se importa UNA vez desde core🫀.js. Fija timeUnit='s' global
// y exporta el easing swiftOut firma para uso en views/comps.

import { animate, createTimeline, stagger, utils, svg, engine, createScope, createDraggable, createAnimatable, onScroll, spring } from 'animejs'

engine.timeUnit = 's'

export const swiftOut = 'cubic-bezier(.771,.029,.189,1.007)'
export const OPAzier  = 'cubic-bezier(.55,0,.1,1)'
export const CLRzier  = 'cubic-bezier(.19,1,.22,1)'
export const LNEzier  = 'cubic-bezier(.65,0,.35,1)'

export {
  animate,
  createTimeline,
  stagger,
  utils,
  svg,
  createScope,
  createDraggable,
  createAnimatable,
  onScroll,
  spring,
}

// Helper: respeta prefers-reduced-motion colapsando duration a casi 0
export const reducedSafe = (opts) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return { ...opts, duration: .001 }
  }
  return opts
}

// Expose global para debugging y acceso desde scripts inline
window.DRP_ANIME = { animate, createTimeline, stagger, utils, svg, swiftOut }
